import React from "react";
import { Helmet } from "react-helmet";
import { helmetJsonLdProp } from "react-schemaorg";

const Seo = () => {
  const metadata = {
    title: "Calcolatore Forfettario",
    metaDescription:
      "Tool gratuito per il calcolo delle spese e dei ricavi del primo anno di Partita IVA in regime forfettario",
  };
  const jsonLd = helmetJsonLdProp({
    "@context": "https://schema.org",
    "@type": "Service",
    name: metadata.title,
    description: metadata.metaDescription,
    keywords: ["crisi d'impresa", "consulenza"],
    brand: "FidoCommercialista",
    slogan:
      "Vuoi sapere quanto incasserai il primo anno di Partita IVA in regime forfettario?",
  });
  return (
    <>
      <Helmet
        title={"Calcolatore Forfettario"}
        titleTemplate={"Calcolatore Forfettario"}
        meta={[
          {
            name: `description`,
            content: metadata.title,
          },
          {
            property: `og:title`,
            content: metadata.title,
          },
          {
            property: `og:description`,
            content: metadata.metaDescription,
          },
          {
            property: `og:type`,
            content: `website`,
          },
          {
            name: `twitter:card`,
            content: `summary`,
          },
          {
            name: `twitter:creator`,
            content: `FidoCommercialista`,
          },
          {
            name: `twitter:title`,
            content: metadata.title,
          },
          {
            name: `twitter:description`,
            content: metadata.metaDescription,
          },
        ]}
        script={[].concat(jsonLd)}
      />
    </>
  );
};

export default Seo;
